/* eslint-env browser */

/**
 * Table of Content implementation
 * Used on post pages, to add a TOC
 */

(function () {
    tocbot.init({
        tocSelector: '.toc',
        contentSelector: '.post',
        hasInnerContainers: true
    });
})();
